/**
 * Depth tokens for the panel's raised, layered look. Every card, tile and
 * primary button pulls its shadow / gradient from here so the whole panel
 * shares one light source (top-left) and one elevation scale.
 */
const ORANGE = '#F4661F'
const ORANGE_LIGHT = '#FF9458'
const ORANGE_DEEP = '#D9500F'

export const depth = {
  // Resting card: hairline top highlight, soft contact shadow, long ambient one.
  card:
    'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(16,24,40,0.06), 0 10px 28px -12px rgba(16,24,40,0.18)',
  cardHover:
    'inset 0 1px 0 rgba(255,255,255,0.9), 0 2px 4px rgba(16,24,40,0.06), 0 18px 36px -14px rgba(16,24,40,0.24)',
  cardBackground: 'linear-gradient(180deg, #FFFFFF 0%, #FBFBFC 100%)',
  // Tinted band behind a card's title.
  headerBackground:
    'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
  // Raised brand tile / button.
  brandGradient: `linear-gradient(145deg, ${ORANGE_LIGHT} 0%, ${ORANGE} 55%, ${ORANGE_DEEP} 100%)`,
  brandShadow:
    'inset 0 1px 0 rgba(255,255,255,0.45), inset 0 -2px 0 rgba(0,0,0,0.12), 0 8px 18px -6px rgba(244,102,31,0.55)',
  brandShadowPressed:
    'inset 0 2px 4px rgba(0,0,0,0.18), 0 3px 8px -4px rgba(244,102,31,0.5)',
  // Recessed input well.
  inset: 'inset 0 1px 2px rgba(16,24,40,0.07)',
  radius: 18
}

// Gradient pairs for icon tiles, keyed by tone.
export const tones = {
  orange: [ORANGE_LIGHT, ORANGE_DEEP, 'rgba(244,102,31,0.5)'],
  blue: ['#6EA8FF', '#2F5FE0', 'rgba(47,95,224,0.45)'],
  green: ['#4ADE80', '#15803D', 'rgba(21,128,61,0.45)'],
  violet: ['#A78BFA', '#6D28D9', 'rgba(109,40,217,0.45)'],
  amber: ['#FCD34D', '#D97706', 'rgba(217,119,6,0.45)'],
  rose: ['#FB7185', '#BE123C', 'rgba(190,18,60,0.45)'],
  slate: ['#94A3B8', '#334155', 'rgba(51,65,85,0.4)']
}

export const toneTile = (tone = 'orange') => {
  const [from, to, glow] = tones[tone] || tones.orange
  return {
    background: `linear-gradient(145deg, ${from} 0%, ${to} 100%)`,
    boxShadow: `inset 0 1px 0 rgba(255,255,255,0.45), inset 0 -2px 0 rgba(0,0,0,0.12), 0 8px 16px -6px ${glow}`,
    color: '#FFFFFF'
  }
}

// sx for any surface that should read as a raised card.
export const cardSx = {
  background: depth.cardBackground,
  border: '1px solid rgba(16,24,40,0.07)',
  borderRadius: `${depth.radius}px`,
  boxShadow: depth.card
}

export default depth
